<template>
    <p v-if="value" class="app-version-label">{{ $t('common.version') }}: {{ value }}</p>
</template>

<script>
import { loadAppVersion } from '@/utils/appVersion';

export default {
    name: 'AppVersionLabel',
    props: {
        product: {
            type: String,
            default: 'weeduc',
        },
    },
    data() {
        return {
            value: '',
        };
    },
    created() {
        loadAppVersion().then((data) => {
            this.value = data?.[this.product] || data?.weeduc || '';
        });
    },
};
</script>

<style scoped>
.app-version-label {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.4;
}
</style>
